/**
 * Created by Jaehyun on 2018-12-01.
 */
import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import cfg from '../config'

class Footer extends Component {
    constructor(props) {
        super(props);

        let date = new Date();

        this.onCall = this.onCall.bind(this);

        this.state = {
            year: date.getFullYear()
        };
    }

    onCall(e) {
        e.preventDefault();
        window.gtag('event', 'call - footer', {
            'event_category' : 'Contact',
            'event_label' : cfg.phone
        });
        window.location.href = 'tel:'+cfg.phone
    }

    render(){
        return (
            <footer>
                <div>

                    <p><Link to={'/terms/'}>
                        <i className={'ico mid ico-stop mr-7'}></i>
                        Terms of Use
                        <i className={'ico mid ico-stop ml-7'}></i>
                    </Link> | <Link to={'/privacy/'}>
                        <i className={'ico mid ico-stop mr-7'}></i>
                        Privacy Policy
                        <i className={'ico mid ico-stop ml-7'}></i>
                    </Link></p>

                    <p>&copy; {this.state.year} Jaehyun Kang. All rights reserved.
                        <span className="sub-desc"> v{this.props.ver}</span></p>
                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/component/footer.js